enum TasksFilterFieldNames {
  Asset = 'asset',
  Filter = 'filter',
  FormCategory = 'formCategory',
  Period = 'period',
  TimelineEndDate = 'timelineEndDate',
  Priority = 'priority',
  Status = 'status',
  Site = 'site',
  SiteArea = 'siteArea',
  SiteAreaIds = 'siteAreaIds',
  TimelineView = 'timelineView',
  ValidityHints = 'validityHints',
  ScopeName = 'scopeName',
}

export default TasksFilterFieldNames;
